<template>
  <div>
    <div class="row">
      <h3>Semantic Segmentation</h3>
      <ResultTables :tasks="semSeg" :additionalHeaders="headers"></ResultTables>
    </div>

    <div class="row">
      <h3>Uncertainty-aware Semantic Segmentation</h3>
      <ResultTables
        :tasks="uncertaintyAwarePanSeg"
        :additionalHeaders="headers"
      ></ResultTables>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ResultTables from "@/views/benchmark/ResultTables";
import moment from "moment";
import { groupBy } from "@/helpers/utils";

export default {
  name: "AdminPanelSubmissionOverview.vue",
  components: {
    ResultTables
  },
  props: {
    userIdCallback: {
      type: Function,
      default: id => id
    }
  },

  methods: {
    submissionMapper(submission) {
      // eslint-disable-next-line
      submission.created_at = moment(submission.created_at).format(
        "YYYY/MM/DD hh:mm"
      );
      return submission;
    },
    groupBy,
    ...mapActions("api", ["getAdminBenchmark"]),
    loadBenchmarks() {
      // Load all the benchmark data
      this.getAdminBenchmark("semSeg").then(data => {
        console.log(data.submissions);
        data.submissions.map(e => {
          e.userId = this.userIdCallback(e.userId);
          return e;
        });

        const semSegItems = data.submissions
          .map(this.submissionMapper)
          .filter(e => e.challenge === "semSeg");
        this.semSeg = this.groupBy(semSegItems, "task");

        const uncertaintyAwarePanSegItems = data.submissions
          .map(this.submissionMapper)
          .filter(e => e.challenge === "pansegUncertain");
        this.uncertaintyAwarePanSeg = this.groupBy(
          uncertaintyAwarePanSegItems,
          "task"
        );
      });
    }
  },
  created() {
    this.loadBenchmarks();
  },
  data() {
    return {
      semSeg: { all: [1, 2, 3, 4, 5] },
      uncertaintyAwarePanSeg: { all: [1, 2, 3, 4, 5] },
      headers: [
        {
          text: "User",
          align: "start",
          filterable: true,
          value: "userId"
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.input-form {
  .row {
    padding-top: 2px;
    padding-bottom: 2px;
  }
}
</style>
